var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.17005 1.25693H1.8854C1.71872 1.25693 1.55886 1.32314 1.441 1.441C1.32314 1.55886 1.25693 1.71872 1.25693 1.8854V9.42698C1.25693 9.59366 1.32314 9.75351 1.441 9.87137C1.55886 9.98923 1.71872 10.0554 1.8854 10.0554H8.17005C8.33673 10.0554 8.49658 9.98923 8.61444 9.87137C8.7323 9.75351 8.79851 9.59366 8.79851 9.42698V1.8854C8.79851 1.71872 8.7323 1.55886 8.61444 1.441C8.49658 1.32314 8.33673 1.25693 8.17005 1.25693ZM1.8854 0C1.38536 0 0.9058 0.198639 0.55222 0.55222C0.198639 0.9058 0 1.38536 0 1.8854V9.42698C0 9.92702 0.198639 10.4066 0.55222 10.7602C0.9058 11.1137 1.38536 11.3124 1.8854 11.3124H8.17005C8.67009 11.3124 9.14964 11.1137 9.50323 10.7602C9.85681 10.4066 10.0554 9.92702 10.0554 9.42698V1.8854C10.0554 1.38536 9.85681 0.9058 9.50323 0.55222C9.14964 0.198639 8.67009 0 8.17005 0H1.8854Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.51367 2.51367H7.54139V3.7706H2.51367V2.51367Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.51367 5.02777H7.54139V6.2847H2.51367V5.02777Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.51367 7.5415H5.656V8.79843H2.51367V7.5415Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.672cdb35b1678b132d62406dc005f0c4.svg";
export { ForwardRef as ReactComponent };